import { TiHomeOutline } from "react-icons/ti";
import { IoNewspaper } from "react-icons/io5";
import { GrInfo } from "react-icons/gr";
import { MdSupportAgent, MdDesignServices } from "react-icons/md";
import { FaCartShopping } from "react-icons/fa6";

const adminSidebarItems = [
  { href: "/admin/categories-list", label: "دسته بندی‌ها" },
  { href: "/admin/orders", label: "لیست سفارشات" },
  { href: "/admin/blogs-list", label: "وبلاگ‌ها" },
  { href: "/admin/add-blog", label: "افرودن وبلاگ" },
  { href: "/admin/add-category", label: "افزودن دسته‌بندی" },
  { href: "/admin/contact-us", label: "تماس‌ها" },
  { href: "/dashboard", label: "داشبورد" },
];

const dashboardSidebarItems = [
  { href: "/dashboard/add-order", label: "افزودن سفارش" },
  { href: "/dashboard/orders", label: "لیست سفارشات" },
];

const headerItems = [
  { href: "/", label: "صفحه اصلی" },
  { href: "/blogs", label: "وبلاگ" },
  { href: "/about-us", label: "درباره ما" },
  { href: "/contact-us", label: "تماس با‌ما" },
  { href: "/design", label: "طراحی آنلاین" },
];

const headerItemsDrawer = [
  { href: "/", label: "صفحه اصلی", icon: <TiHomeOutline /> },
  { href: "/blogs", label: "وبلاگ", icon: <IoNewspaper /> },
  { href: "/about-us", label: "درباره ما", icon: <GrInfo /> },
  { href: "/design", label: "طراحی آنلاین", icon: <MdDesignServices /> },
  { href: "/add-order", label: "سفارش تابلو", icon: <FaCartShopping /> },
  { href: "/contact-us", label: "تماس با‌ما", icon: <MdSupportAgent /> },
];

const ordersType = [
  { id: 1, label: "نمیدانم، نیاز به مشاوره دارم" },
  { id: 5, label: "حروف چنلیوم" },
  { id: 6, label: "پلاستیک" },
  { id: 7, label: "لبه سوئدی" },
  { id: 8, label: "لبه سوئدی مکس" },
  { id: 9, label: "تابلو روان" },
  { id: 10, label: "بیلبورد" },
];

const costAmountOptions = [
  { id: 0, label: "نمیدانم، بستگی به طرح دارد" },
  { id: 5_000_000, label: "2 تا 5 میلیون تومان" },
  { id: 10_000_000, label: "۵ تا ۱۰ میلیون تومان" },
  { id: 15_000_000, label: "۱۰ تا ۱۵ میلیون تومان" },
  { id: 20_000_000, label: "۱۵ تا ۲۰ میلیون تومان" },
  { id: 30_000_000, label: "۲۰ تا ۳۰ میلیون تومان" },
  { id: 40_000_000, label: "۳۰ تا ۴۰ میلیون تومان" },
  { id: 60_000_000, label: "۴۰ تا ۶۰ میلیون تومان" },
  { id: 90_000_000, label: "۶۰ تا ۹۰ میلیون تومان" },
  { id: 120_000_000, label: "۹۰ تا ۱۲۰ میلیون تومان" },
  { id: 500_000_000, label: "بالای ۱۲۰ میلیون تومان" },
];

const orderStatuses = [
  { id: "UNREAD", label: "در حال بررسی" },
  { id: "ًREAD", label: "مشاهده شده توسط کارشناس" },
  { id: "APPROVED", label: "تایید شد" },
  { id: "DISSUADED", label: "منصرف شده" },
];

const contactUsType = [
  { id: "pricing", label: "اطلاع از قیمت‌ها" },
  { id: "technical", label: "فنی (گزارش ایرادات سایت)" },
  { id: "feedback", label: "پیشنهادات و انتقادات" },
  { id: "reservation_change", label: "تغییر رزور" },
  { id: "general", label: "پرسش‌های دیگر" },
];

export {
  contactUsType,
  orderStatuses,
  headerItems,
  headerItemsDrawer,
  ordersType,
  costAmountOptions,
  adminSidebarItems,
  dashboardSidebarItems,
};
